import React from "react";
import { UnauthorizedError } from "../../components/generic/UnauthorizedError";

export const SeahorsePage: React.FunctionComponent = () => {
  return <UnauthorizedError />;
};
